<template>
  <el-dialog
    width="360px"
    v-drag
    :title="`设置${templateTitle}名称`"
    class="kye-dialog__modal-in-tab"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="escape"
    :visible.sync="show"
    custom-class="kye-custom-filter-template-name"
    @close="onClose">
    <el-form :model="model" :rules="rules" ref="form" label-width="70px">
      <el-form-item :label="`${templateTitle}名称`" prop="templateName">
        <el-input
          v-model="model.templateName"
          :placeholder="`请输入${templateTitle}名称`"
          :maxlength="100">
        </el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="submit">保存</el-button>
      <el-button @click="show = false">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'template-name-dialog',
    props: {
      escape: Boolean,
      model: Object
    },
    data () {
      return {
        show: false,
        rules: {
          templateName: [
            { required: true, message: '请输入名称', trigger: 'blur' }
          ]
        },
      }
    },
    computed: {
      templateTitle() {
        return this.model.folderFlag === 1 ? '文件夹' : '模版'
      }
    },
    methods: {
      submit () {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$emit('change')
            this.show = false
          }
        })
      },
      onClose () {
        this.$refs.form && this.$refs.form.clearValidate()
      }
    }
  }
</script>

<style lang="scss">
  .kye-custom-filter-template-name > .el-dialog__body {
    padding-bottom: 1px;
    margin: 24px 0;
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/template-name-dialog.vue